import React, { Fragment } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CopyToClipboard from 'react-copy-to-clipboard';
import { TextCensor, RegExpMatcher, englishDataset, englishRecommendedTransformers } from 'obscenity';


import "../../css/GameRoom.css"
import GameInformative from "../gametools/GameInformative";


const InvaderGame = ({userData, gameData, scoreData, userGamesData, handleNewHighScore}) => {
  const navigate = useNavigate();

  const [unloading, setUnloading] = useState(false);
  const [showCopy, setShowCopy] = useState(false);
  const [allLoaded, setAllLoaded] = useState(false);
  const [inappropriateScoreId, setInappropriateScoreId] = useState(null);

  const unityCanvasRef = useRef(null);

  const { unityProvider, sendMessage, isLoaded, loadingProgression, addEventListener, removeEventListener, unload } =
    useUnityContext({    
      loaderUrl: "/assets/games/invader/InvaderV1.1.1.loader.js",
      dataUrl: "/assets/games/invader/InvaderV1.1.1.data",
      frameworkUrl: "/assets/games/invader/InvaderV1.1.1.framework.js",
      codeUrl: "/assets/games/invader/InvaderV1.1.1.wasm",
  });

  useEffect(()=>{
    if(userData == null || gameData == null || userData == undefined || gameData == undefined)
      navigate("/gameroom")
  },[userData, gameData])

  useEffect(()=>{
    if(gameData !== null && gameData !== undefined && isLoaded){
      if(gameData.gameDesign["gameicon"] !== null){
        sendMessage("LoadingCanvas", "SetLoadingData", "gameicon," + gameData.gameDesign["gameicon"]);
      }
  
      if(gameData["gameName"] !== null){
        sendMessage("LoadingCanvas", "SetLoadingData", "gameName," + gameData["gameName"]);
      }
  
      if(gameData["userName"] !== null){
        sendMessage("LoadingCanvas", "SetLoadingData", "userName," + gameData["userName"]);
      }

      const gameDesign = gameData.gameDesign;
      const filteredDesigns = Object.keys(gameDesign)
      .filter((key) => gameDesign[key].includes("https://") && !key.endsWith("sfx"))
      .reduce((obj, key) => {
        obj[key] = gameDesign[key];
        return obj;
      }, {});

      sendMessage("LoadingCanvas", "SetLoadingAmount", Object.keys(filteredDesigns).length);
      console.log("loadingAmount: " + Object.keys(filteredDesigns).length);
    }
  },[gameData, isLoaded]);

  useEffect(() => {
    if (isLoaded) {

      console.log(scoreData);
      console.log(gameData);

      const delay = 100; // Adjust delay as needed (in milliseconds)

      const sendMessagesWithDelay = (items, messageType, callback) => {
        let index = 0;
        const keys = Object.keys(items);
        const sendNextMessage = () => {
          if (index < keys.length) {
            const key = keys[index];
            if (typeof items[key] === "string") {
              //console.log(messageType + " " + key);
              sendMessage("GameAssetLoader", messageType, key + "," + items[key]);
            }
            else if (Number.isInteger(items[key])) { // Check if it's an integer
              console.log(messageType + " " + key);
              sendMessage("GameAssetLoader", messageType, key + "," + items[key].toString()); // Convert to string
            }   
            index++;
            setTimeout(sendNextMessage, delay);
          } else {
            if (callback) callback();
          }
        };

        sendNextMessage();
      };

      const sendHighscoreWithDelay = (scoreData) => {
        Object.values(scoreData)
          .forEach((item, idx) => {
            const scoreString = item.scoreId + "," + item.location + "," + item.name + "," + item.score + "," + item.timestamp.toDate().toISOString();
            // Set a delay before sending each highscore
            setTimeout(() => {
              sendMessage("HighscoreManager", "SetHighscoreData", scoreString);
            }, idx * 1000);  // Delay each highscore by 1 second (1000ms)
          });
      };

      if(!allLoaded){
        // Sending gameData messages
        sendMessagesWithDelay(gameData, "SetGameData", () => {
          // Sending gameDesign messages
          const gameDesign = gameData.gameDesign;
          sendMessagesWithDelay(gameDesign, "SetGameDesign", () => {
            if(scoreData !== null && scoreData !== undefined){
              sendMessage("HighscoreManager", "ResetHighscoreFromReact");
              setInappropriateScoreId(null);

              sendHighscoreWithDelay(scoreData);

              // after the last highscore has been queued:
              const highscoreDelay = Object.values(scoreData).length * 1000;
              setTimeout(() => {
                sendMessage("HighscoreManager", "AllHighscoreSent");
                sendMessage("GameAssetLoader", "SetAllDataSent");
                setAllLoaded(true);
              }, highscoreDelay);
            }
            else {
              // no highscores, just finish
              setTimeout(() => {
                sendMessage("HighscoreManager", "AllHighscoreSent");
                sendMessage("GameAssetLoader", "SetAllDataSent");
                setAllLoaded(true);
              }, delay);
            }
          });
        });
      }
      else{
        if(scoreData !== null && scoreData !== undefined){
          sendMessage("HighscoreManager", "ResetHighscoreFromReact");
          setInappropriateScoreId(null);
          sendHighscoreWithDelay(scoreData);

          const highscoreDelay = Object.values(scoreData).length * 1000;
            setTimeout(() => {
              sendMessage("HighscoreManager", "AllHighscoreSent");
              setAllLoaded(true);
          }, highscoreDelay);
        }
      }
    }
  }, [gameData, isLoaded, allLoaded, scoreData, sendMessage]);


  useEffect(() => {
    async function unloadUnity() {
      await unload();
      setUnloading(false);
      //window.location.href = "https://www.gametory.com/gameroom"
      window.location.href = `${window.location.origin}/gameroom`;
    }

    if (unloading) {
      unloadUnity();
    }
  }, [unloading, unload, navigate]);

  // HIGH SCORE
  const handleHighScore = useCallback((newScore) => {
    // Split the string into parts
    const parts = newScore.split(',');

    // Extract values
    const scoreId = parts[0];
    const name = parts[1]; 
    const score = parseInt(parts[2]);

    const matcher = new RegExpMatcher({ ...englishDataset.build(), ...englishRecommendedTransformers });
    const hasMatch = matcher.hasMatch(name);

    if (hasMatch) {
      // queue the Unity message on the next tick
      setInappropriateScoreId(scoreId);

      // then show the alert
      setTimeout(() => {
        alert("The name contains inappropriate language. Your score is not saved");
      }, 1000);
      return;
    }
    else{
      const newHighScore = {
        scoreId: scoreId,
        name: name,
        score: score,
        location: "web",
      };

      handleNewHighScore(newHighScore);
    }

  }, []);

  useEffect(() => {
    if (inappropriateScoreId && isLoaded) {
      sendMessage("HighscoreManager", "SetInappropriate", inappropriateScoreId);
    }
  }, [inappropriateScoreId, isLoaded, sendMessage]);

  useEffect(() => {
    addEventListener("SetHighScoreWithReact", handleHighScore);
    return () => {
      removeEventListener("SetHighScoreWithReact", handleHighScore);
    };
  }, [addEventListener, removeEventListener, handleHighScore]);

  //NAVIGATION
  const handleBackClick = () =>{
    setUnloading(true);
  }

  const handleShareClick = () =>{
    if(showCopy)
      return;

    setShowCopy(true);
    setTimeout(()=>{
      setShowCopy(false);
    }, 5000);
  }

  return (
    <Fragment>
      <div className="game-page-body">
        <img 
          className="center-child" 
          src="/assets/nav/eject_button.png"
          style={{position:"absolute", width:"40px", height:"40px", top:"2%", left:"10px", backgroundColor:"black", borderRadius:"50%", margin:"0px 5px", cursor:"pointer", zIndex:"60"}}
          onClick={()=>handleBackClick()}
        />

        <img className="game-howto" src="/assets/games/invader/invader_howto.png"/>

        {showCopy &&
          <div 
            style={{
              zIndex:"300", 
              width:"400px", 
              height:"300px", 
              opacity:"0.9", 
              position:"absolute", 
              top:"60dvh", 
              left:"50%", 
              textAlign:"center", 
              transform:"translate(-50%,-50%)"}}
          >
            <div style={{position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", fontSize:"2.5em", width:"80%", color:"#00A651"}}>
              <div style={{textShadow: "2px 2px 4px rgba(0, 0, 0, 0.43)",}}>LINK COPIED...</div>
              <div style={{textShadow: "2px 2px 4px rgba(0, 0, 0, 0.43)",}}>SHARE YOUR GAME!</div>
              <div style={{fontSize:"0.5em", color:"black", marginTop:"10px"}}>{"(Paste the link into any device)"}</div>
            </div>
            <img src="/assets/gameinfo/gamesharebox.png" style={{width:"100%", objectFit:"contain"}}/>
          </div>
        }

        {!allLoaded &&
          <div style={{position:"absolute", display:"flex", justifyContent:"center", alignItems:"center", width:"150px", height: "45px", top:"25dvh", left:"50%", zIndex:"200"}}>
            <img src="/assets/icon/textbg_yellow.png" style={{position:"absolute", width:"100%", zIndex:"201"}}/>
            <p style={{color:"black", zIndex:"202", position:"absolute", fontSize:"20px", fontWeight:"600"}}>LOADING... {Math.round(loadingProgression * 100) === 100 ? 99 : Math.round(loadingProgression * 100)}%</p>
          </div>
        }

        <div ref={unityCanvasRef} className="unity-container">
          <Unity 
            unityProvider={unityProvider} 
            className="unity-style"
          />
        </div>

        <div style={{ width: "100%", display: "flex", justifyContent: "center", padding:"25px 0px 5px 0px" }}>
          {userData !== undefined &&
            <CopyToClipboard text={"https://www.gametory.com/gameroom?gameId=" + userData.userId + "_" + gameData.gameId} onCopy={handleShareClick}>
              <img 
                onClick={()=>handleShareClick()}
                src="/assets/nav/sharegame_button.png"
                style={{width:"250px", cursor: "pointer", margin: "0 auto", zIndex:"50"}}
              />
            </CopyToClipboard>
          }
        </div>

        <GameInformative
          userGamesData={userGamesData}
          userData={userData}
          gameData={gameData}
          handleBackClick={handleBackClick}
        />

        <div>
          <img 
              src="/assets/games/gameroom/cardboard.png"
              style={{position:"fixed", top:"0", left:"0", height: "100vh", width:"100%", zIndex:"-10", pointerEvents: "none", userSelect:"none", objectFit:"cover"}}
          />

          <img 
              src="/assets/games/gameroom/gr_star.png"
              style={{position:"absolute", width:"20px", top:"1%", left:"15%", transform:"rotate(12deg)", zIndex:"-5"}}
          />

          <img 
              src="/assets/games/gameroom/gr_star.png"
              style={{position:"absolute", width:"20px", top:"5%", left:"80%", transform:"rotate(30deg)", zIndex:"-5"}}
          />

          <img 
              src="/assets/games/gameroom/gr_star.png"
              style={{position:"absolute", width:"20px", top:"30%", left:"6%", transform:"rotate(-5deg)", zIndex:"-5"}}
          />

          <img 
              src="/assets/games/gameroom/gr_star.png"
              style={{position:"absolute", width:"20px", top:"60%", left:"96%", transform:"rotate(-5deg)", zIndex:"-5"}}
          />
          <img 
              src="/assets/games/gameroom/gr_star.png"
              style={{position:"absolute", width:"20px", top:"50%", left:"27%", transform:"rotate(-5deg)", zIndex:"-5"}}
          />
        </div>

      </div>
    </Fragment>
  );
}

export default InvaderGame;